module.exports = __webpack_public_path__ + "res/ic_delete_bg.7a08a63b880374e52bb2d800747d803c.png";